import React from 'react'
import { Helmet } from 'react-helmet'
import SecondaryHeader from '../masterLayout/SecondaryHeader'

const MedicalProviders = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Medical Providers | Bennabix</title>
      </Helmet>
      <SecondaryHeader
        page_title="Medical Providers"
        banner={require('../assets/images/providers/banner.jpg')}
      />
      <div className="sectionWrap">
        <div className="sectionContainer">
          <div className="medical-providers-page">
            <section className="intro-copy">
              <h3 className="lead">Because better outcomes deserve better options.</h3>
              <p>
                For millions living with chronic conditions, the path to relief has been narrow, often limited to pharmaceuticals with harsh side effects. The future of care is expanding with the option of medical cannabis.
              </p>
              <p className="strong">Bennabix is helping bring that future into the present.</p>
            </section>

            <section className="bp-highlight providers-highlight">
              <div className="two-col">
                <div className="col text">
                  <p>
                    We’re integrating medical cannabis into the healthcare conversation as a recognized therapeutic tool. Providing coverage, guidance, and access that remove barriers and reduce stigma.
                  </p>
                  <p>
                    Because when patients have access to safe, effective alternatives, lives improve. Productivity improves. Outcomes improve.
                  </p>
                </div>
                <div className="col media">
                  <img src={require('../assets/images/providers/hands-cannabis.jpg')} alt="Clinician holding cannabis and dropper" />
                </div>
              </div>
            </section>

            <section className="section-copy">
              <h5>Expert Support</h5>
              <p>
                As medical cannabis becomes legal in more states across the country and more patients are using cannabis to treat their conditions and side effects, the need for cannabis education is growing. With this growth there is a knowledge-gap around this plant and many are not comfortable with the conversation, patients or professionals.
              </p>
              <p>
                That is why Bennabix is focused on supporting medical cannabis patients with educational resources. We understand that professionals need to continue learning as well.
              </p>
              <p>
                If you are a healthcare professional looking to learn more about how you can support your medical cannabis patients and gain CMEs, TheAnswerPage offers excellent resources.
              </p>
              <hr />
              <p className="offer"><strong>Bennabix has secured a special offer and you can save 10%</strong> if you reference the code <strong>BENNABIX</strong> when you register at <a href="https://TheAnswerPage.com" target="_blank" rel="noreferrer">TheAnswerPage.com</a>.</p>
              <div className="answerpage-logo">
                <img src={require('../assets/images/answerpage.png')} alt="The Answer Page" />
              </div>
              <p className="answerpage-copy">
                <a
                  href="http://theanswerpage.com/"
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ color: '#082F58' }}
                >
                  TheAnswerPage.com
                </a>{' '}
                creates tailored multi-accredited medical educational programs for Departments of Public Health, state medical societies, hospitals and medical schools. Currently,{' '}
                <a
                  href="http://theanswerpage.com/"
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ color: '#082F58' }}
                >
                  TheAnswerPage.com
                </a>{' '}
                offers{' '}
                <a
                  href="https://www.theanswerpage.com/product/a-nationally-approved-cme-ce-medical-marijuana-course/"
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ color: '#082F58' }}
                >
                  “A Nationally Approved CME/CE Medical Marijuana Course,”
                </a>{' '}
                <a
                  href="https://www.theanswerpage.com/product/cbd-in-clinical-care/"
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ color: '#082F58' }}
                >
                  “CBD in Clinical Care”
                </a>{' '}
                and numerous state required courses, including{' '}
                <a
                  href="https://www.theanswerpage.com/product/the-new-york-medical-cannabis-program-required-course-bundle/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  “The New York Medical Cannabis Required Course Bundle,”
                </a>{' '}
                <a
                  href="https://www.theanswerpage.com/product/the-pennsylvania-medical-marijuana-program-required-course-bundle/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  "The Pennsylvania Medical Marijuana Required Course Bundle,”
                </a>{' '}
                <a
                  href="https://www.theanswerpage.com/product/the-ohio-healthcare-provider-medical-marijuana-course-bundle-for-certification-or-maintenance-of-the-ctr/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  "The Ohio Medical Marijuana Required Course Bundle for certification (or maintenance of the CTR),”
                </a>{' '}
                <a
                  href="https://www.theanswerpage.com/product/the-utah-medical-cannabis-program-required-course-bundle/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  "The Utah Medical Cannabis Required Course Bundle,”
                </a>{' '}
                and{' '}
                <a
                  href="https://www.theanswerpage.com/product/the-west-virginia-medical-cannabis-program-required-course-bundle/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  "The West Virginia Medical Cannabis Required Course Bundle,”
                </a>
                .
              </p>
              <hr />
            </section>

            <section className="footer-cta">
              <h5>Contact Us</h5>
              <p>
                If your patients are interested in medical cannabis, we’re the partner you can count on to provide the necessary support.
              </p>
              <p>
                Contact us today at <a href="mailto:team@bennabix.com">team@bennabix.com</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default MedicalProviders